import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, NewButton, TaglineTitleContent } from 'newComponents'
import Speakers from '../../newComponents/WebinarsNew/Speakers'
import stars from '../../images/stars.jpg'
import './styles.scss'

const TextSpeakerColumns = (props) => {
  const { data } = props
  const { primary, items, __typename } = data
  const { content, cta_link: ctaLink, cta_text: ctaText, tagline, title } = primary

  // content checks
  const titleHtml = title?.html
  const contentHtml = content?.html
  const taglineHtml = tagline?.html
  const hasCta = ctaLink?.url && ctaText?.text

  const speakers = []

  items.forEach((speaker) => {
    const { speaker_avatar: avatar, speaker_logo: logo, speaker_name: name, speaker_role: role } = speaker
    speakers.push({ avatar, logo, name, role })
  })

  const type = __typename === 'PrismicPageBodyTextSpeakerColumns' ? 'page' : ''

  return (
    <OnVisible className="text-speaker-columns">
      <Section className="text-speaker-columns-container">
        <div>
          <TaglineTitleContent tagline={taglineHtml} content={contentHtml} title={titleHtml} />
          {hasCta && <NewButton to={ctaLink.url}>{ctaText.text}</NewButton>}
        </div>
        <Speakers speakers={speakers} variant={type} />
      </Section>
    </OnVisible>
  )
}

export default TextSpeakerColumns
